import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { apiSetupStatus, apiWhoami, type AdminUser } from './shared'
import { LoginPage } from './LoginPage'
import { SetupPage } from './SetupPage'
import { Dashboard, DashboardHome } from './Dashboard'
import { HeroEditor } from './HeroEditor'
import { ContattiEditor } from './ContattiEditor'
import { EntityEditor } from './EntityEditor'
import { MediaManager } from './MediaManager'
import { SectionsEditor } from './SectionsEditor'
import { SiteEditor } from './SiteEditor'

export function AdminApp() {
  const [checking, setChecking] = useState(true)
  const [needsSetup, setNeedsSetup] = useState(false)
  const [user, setUser] = useState<AdminUser | null>(null)
  const loc = useLocation()
  const nav = useNavigate()

  useEffect(() => {
    document.body.classList.add('admin')
    return () => document.body.classList.remove('admin')
  }, [])

  async function refresh() {
    setChecking(true)
    try {
      const status = await apiSetupStatus()
      if (status.needs_setup) {
        setNeedsSetup(true); setUser(null); return
      }
      setNeedsSetup(false)
      const who = await apiWhoami()
      setUser(who.user)
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => { void refresh() }, [])

  if (checking) {
    return <div style={{ padding: 40, color: 'var(--fg-muted)', fontFamily: 'var(--font-body)' }}>…</div>
  }

  if (needsSetup) {
    return <SetupPage onSetupDone={() => { void refresh() }} />
  }

  if (!user) {
    // Strip /admin prefix — show login page regardless of deep path
    if (loc.pathname !== '/admin' && loc.pathname !== '/admin/') {
      return <Navigate to="/admin" replace />
    }
    return <LoginPage onLoggedIn={() => { void refresh() }} />
  }

  return (
    <Routes>
      <Route element={<Dashboard user={user} onLoggedOut={() => { setUser(null); nav('/admin', { replace: true }) }} />}>
        <Route index element={<DashboardHome />} />
        <Route path="sections"  element={<SectionsEditor />} />
        <Route path="hero"      element={<HeroEditor />} />
        <Route path="contatti"  element={<ContattiEditor />} />
        <Route path="media"     element={<MediaManager />} />
        <Route path="site"      element={<SiteEditor />} />
        <Route path="identita"   element={<EntityEditor entity="identita" />} />
        <Route path="singoli"    element={<EntityEditor entity="singoli" />} />
        <Route path="videos"     element={<EntityEditor entity="videos" />} />
        <Route path="gallery"    element={<EntityEditor entity="gallery" />} />
        <Route path="repertorio" element={<EntityEditor entity="repertorio" />} />
        <Route path="date_live"  element={<EntityEditor entity="date_live" />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Route>
    </Routes>
  )
}
